<template lang="html">
    <div class="call-controls">
        <!--<div class="call-control">-->
            <!--<i class="fas fa-pause"></i>-->
        <!--</div>-->
        <div class="call-control" @click="toggleMic" v-if="hasMic">
            <i class="fas" :class="{'fa-microphone': !this.micOff, 'fa-microphone-slash': this.micOff}"></i>
        </div>
        <div class="call-control disabled" @click="retryDevices" v-else>
            <i class="fas fa-microphone-slash"></i>
        </div>
        <div class="call-control" @click="toggleVideo" v-if="hasVideo">
            <i class="fas" :class="{'fa-video': !this.videoOff, 'fa-video-slash': this.videoOff}"></i>
        </div>
        <div class="call-control disabled" @click="retryDevices" v-else>
            <i class="fas fa-video-slash"></i>
        </div>
        <div class="call-control end-call" @click="$emit('close')">
            <i class="fas fa-phone"></i>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    hasMic: {
      type: Boolean,
      default: false
    },
    hasVideo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      micOff: false,
      videoOff: false
    };
  },
  methods: {
    toggleMic(){
      this.micOff = !this.micOff;
      this.$emit('micStatus', !this.micOff);
    },
    toggleVideo(){
      this.videoOff = !this.videoOff;
      this.$emit('videoStatus', !this.videoOff);
    },
    retryDevices(){
      this.$emit("retryDevices");
      console.log('Retry device');
    },
  }
}
</script>

